

















import QErrors from "@/common/qErrors.vue";
import { Component, Prop, PropSync } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
  name: "qInputNumber",
  components: { QErrors },
})
export default class qInputNumber extends Vue {
  @PropSync("value", {
    type: [Number, String],
  })
  public valueSync;

  @Prop({
    default: false,
  })
  public required;

  @Prop({
    type: String,
    required: true,
  })
  public name;

  @Prop({
    type: String,
    default: "",
  })
  public placeholder;

  @Prop({
    type: Number,
    default: null,
  })
  public min;

  @Prop({
    type: Boolean,
    default: false,
  })
  public disabled;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public errors;

  public clearError() {
    this.$emit("update:errors", { ...this.errors, ...{ [this.name]: [] } });
  }

  public validateQuantity() {
    this.$emit("validateQuantity");
  }
}
